<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field v-model="message" rows="3" autosize label="消息内容：" type="textarea" placeholder="请输入消息内容"
          :show-word-limit="msgTypeChecked ==
      'YD.CYW.Class.TicketOrderDetailSchedulingWeiXinNotice'
      " :maxlength="msgTypeChecked ==
        'YD.CYW.Class.TicketOrderDetailSchedulingWeiXinNotice'
        ? 200
        : null
      " />

        <van-field name="nodeCheckboxGroup" label="上车站点：">
          <template #input>
            <van-checkbox-group v-model="startNodeChecked">
              <van-checkbox v-for="node in startNodeList" v-bind:key="node.GID" :name="node.NodeGID" shape="square"
                style="margin-top: 5px;">{{ node.NodeName }}</van-checkbox>
              <span style="color: red;">*不选择则是发送给所有站点</span>
            </van-checkbox-group>
          </template>
        </van-field>

        <van-field name="nodeCheckboxGroup" label="下车站点：">
          <template #input>
            <van-checkbox-group v-model="arrivalNodeChecked">
              <van-checkbox v-for="node in arrivalNodeList" v-bind:key="node.GID" :name="node.NodeGID" shape="square"
                style="margin-top: 5px;">{{ node.NodeName }}</van-checkbox>
              <span style="color: red;">*不选择则是发送给所有站点</span>
            </van-checkbox-group>
          </template>
        </van-field>

        <van-field name="ticketStatusCheckboxGroup" label="状态选择：">
          <template #input>
            <van-checkbox-group v-model="ticketStatusChecked">
              <van-checkbox name="2" shape="square" style="margin-top: 5px;">已售</van-checkbox>
              <van-checkbox name="8,9" shape="square" style="margin-top: 5px;">已检</van-checkbox>
              <van-checkbox name="4" shape="square" style="margin-top: 5px;">已订</van-checkbox>
              <span style="color: red;">*不选择则是发送给所有有效票</span>
            </van-checkbox-group>
          </template>
        </van-field>
        <van-field name="msgSendSwitch" label="消息重发：" v-if="msgTypeChecked ==
      'YD.CYW.Class.TicketOrderDetailSchedulingWeiXinNotice'
      ">
          <template #input>
            <van-switch v-model="fallbackWxToSMS" size="22px">无法发送微信时转为发送短信</van-switch>
          </template>
        </van-field>
        <van-field name="msgTypeRadio" label="消息类型：">
          <template #input>
            <van-radio-group v-model="msgTypeChecked" direction="horizontal">
              <van-radio name="YD.CYW.Class.TicketOrderDetailSchedulingSMSNotice">短信</van-radio>
              <van-radio name="YD.CYW.Class.TicketOrderDetailSchedulingWeiXinNotice">微信（200字内）</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>

      <div style="margin: 16px; padding: 20px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "消息发送", //页面标题
      startNodeList: JSON.parse(localStorage.getItem("startNodeList")), // 上车站点列表
      arrivalNodeList: JSON.parse(localStorage.getItem("arrivalNodeList")), // 下车站点列表
      operObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员对象
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //班次对象
      startNodeChecked: [], // 上车选择的站点
      arrivalNodeChecked: [], // 下车选择的站点
      message: "", //消息内容
      ticketStatusChecked: [], //车票状态选择
      fallbackWxToSMS: true,
      msgTypeChecked: "YD.CYW.Class.TicketOrderDetailSchedulingSMSNotice", //消息类型选择
    };
  },
  watch: {},
  methods: {
    onSubmit() {
      if (!this.message || !this.message.trim()) {
        this.$dialog.alert({
          title: "提示",
          message: "消息内容不允许为空",
        });
        return;
      }
      let text = this.message;
      text = JSON.stringify(text); // 进行json字符串的转义，或者可以使用Ext.JSON.encodeString方法。只是对汉字等编码的处理不同
      text = text.substr(1, text.length - 2); // 去除第一个和最后一个双引号
      this.$http
        .post(
          this.$api.TicketOrderDetailSendMsgNotice,
          this.$qs.stringify({
            LineClassDayGID: this.lineClassDay.GID,
            TicketStatusList: this.ticketStatusChecked.toString(),
            // NodeGIDList: this.nodeChecked.toString(),
            StartNodeGIDList: this.startNodeChecked.toString(),
            ArrivalNodeGIDList: this.arrivalNodeChecked.toString(),
            MsgTypeCode: this.msgTypeChecked,
            FallbackWxToSMS: this.fallbackWxToSMS,
            NoticeContent: text,
            OperGID: this.operObj.GID, //操作员GID
            OperCode: this.operObj.UserCode, //操作员代码
            OperName: this.operObj.UserName, //操作员名称
          })
        )
        .then((res) => {
          if (res.success) {
            this.$toast("消息发送成功");
            //1s后返回班次列表
            setTimeout(() => {
              this.$router.back();
            }, 1000);
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
          }
        });
    },
  },
  mounted: function () { },
  created() { },
};
</script>

<style scoped lang="less"></style>
